export const API_BASE_URL =
  "https://api.dwellium.in/api/v1/";


// export const API_BASE_URL =
//   "http://localhost:5200/api/v1/";


export const API_PATHS = {

  userlogin: "user/login",
  register: "user/register",
  verifyotp: "user/verify-otp",
  forgotpassword: "user/forgotpassword",
  setpassword: "user/setpassword",
  adminlogin: "sadmin/login",
  uploadFile: "sadmin/upload",
  userUploadFile: "user/upload",
  getProfile: "user/get/profile",
  editprofile: "user/editprofile",
  getAmenity: "sadmin/amenity/get",
  editAmenity: "sadmin/amenity/edit",
  deleteAmenity: "sadmin/amenity/delete",

  // get amenity for , hotel admin page 
  getuserAmenity: "user/amenity/get",

  //organization-- 
  addOrganization: "sadmin/organization/add",
  getOrganization: "sadmin/organization/get",
  editOrganization: "sadmin/organization/edit",
  deleteOrganization: "sadmin/organization/delete",

  //travel hotel
  addtravelHotel: "user/travelhotel/add",
  gettravelHotel: "user/travelhotel/get",
  edittravelHotel: "user/travelhotel/edit",
  deletetravelHotel: "user/travelhotel/delete",

  //hotel
  addHotel: "user/hotel/add",
  getHotel: "user/hotel/get",
  editHotel: "user/hotel/edit",
  deleteHotel: "user/hotel/delete",


  //travel room type
  addroomType: "user/roomtype/add",
  getroomType: "user/roomtype/get",
  editroomType: "user/roomtype/edit",
  deleteroomType: "user/roomtype/delete",


  //travel vehicle type
  addvehicleType: "user/vehicletype/add",
  getvehicleType: "user/vehicletype/get",
  editvehicleType: "user/vehicletype/edit",
  deletevehicleType: "user/vehicletype/delete",



  //place
  addPlace: "user/place/add",
  getPlace: "user/place/get",
  editPlace: "user/place/edit",
  deletePlace: "user/place/delete",

  //place
  addFerry: "user/ferry/add",
  getFerry: "user/ferry/get",
  editFerry: "user/ferry/edit",
  deleteFerry: "user/ferry/delete",

  //package category
  addpackageCategory: "user/packagecategory/add",
  getpackageCategory: "user/packagecategory/get",
  editpackageCategory: "user/packagecategory/edit",
  deletepackageCategory: "user/packagecategory/delete",


  //package 
  addpackage: "user/package/add",
  getpackage: "user/package/get",
  editpackage: "user/package/edit",
  deletepackage: "user/package/delete",

  addoptions: "user/package/addoptions",
  editoptions: "user/package/editoptions",
  getoptions: "user/package/getoptions",
  deleteoptions: "user/package/deleteoptions",

  addDayPlan: "user/package/addDayPlan",
  editDayPlan: "user/package/editDayPlan",
  getDayPlan: "user/package/getDayPlan",

  addDayHotel: "user/package/addDayHotel",
  editDayHotel: "user/package/editDayHotel",

  addDayVehicle: "user/package/addDayVehicle",
  editDayVehicle: "user/package/editDayVehicle",

  addDayFerry: "user/package/addDayFerry",
  editDayFerry: "user/package/editDayFerry",
  deleteDayFerry: "user/package/deleteDayFerry",

  addDayActivity: "user/package/addDayActivity",
  editDayActivity: "user/package/editDayActivity",
  deleteDayActivity: "user/package/deleteDayActivity",

  calculatePackageOption: "user/package/calculatePackageOption",


  // activity
  addactivity: "user/activity/add",
  getactivity: "user/activity/get",
  editactivity: "user/activity/edit",
  deleteactivity: "user/activity/delete",

  // staff
  addstaff: "user/staff/add",
  getstaff: "user/staff/get",
  editstaff: "user/staff/edit",
  deletestaff: "user/staff/delete",

  // vendor
  addvendor: "user/vendor/add",
  getvendor: "user/vendor/get",
  editvendor: "user/vendor/edit",
  deletevendor: "user/vendor/delete",

  // agent
  addagent: "user/agent/add",
  getagent: "user/agent/get",
  editagent: "user/agent/edit",
  deleteagent: "user/agent/delete",

  //  leads
  addlead: "user/lead/add",
  getlead: "user/lead/get",
  editlead: "user/lead/edit",
  deletelead: "user/lead/delete",
  addleadactivity: "user/leadactivity/add",
  getleadactivity: "user/leadactivity/get",
  leadsync: "user/leadsync",

  // expense

  addexpense: "user/expense/add",
  getexpense: "user/expense/get",
  editexpense: "user/expense/edit",
  deleteexpense: "user/expense/delete",



  //quotation
  generateQuotation: "user/quotation/generate",
  editQuotation: "user/quotation/edit",
  getQuotation: "user/quotation/get",
  deleteQuotation: "user/quotation/delete",
  sendQuotation: "user/quotation/send",
  resendQuotation: "user/quotation/resend",
  recalculateQuotation: "user/quotation/recalculate",
  updatehotelQuotation: "user/quotation/updatehotel",
  updatevehicleQuotation: "user/quotation/updatevehicle",
  updateferryQuotation: "user/quotation/updateferry",


  //booking
  addBooking: "user/booking/create",
  getBookings: "user/booking/getBookings",
  addcustomerpayment: "user/booking/addcustomerpayment",
  addvendorpayment: "user/booking/addvendorpayment",
  getVendorPayments: "user/booking/getVendorPayments",
  getCustomerPayments: "user/booking/getCustomerPayments",
  getupcomingBooking: "user/booking/getupcomingBookings",
  generateinvoice: "user/booking/generateinvoice",
  getInvoice: "user/booking/getInvoice",
  sendInvoice: "user/booking/sendInvoice"



};
